import Header from "../components/Header";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";

function TermsOfService() {
  return (
    <div className="bg-white min-h-screen">
      <Header />

      <PageBanner
        title="Terms of Service"
        subtitle="Please read these terms carefully before using our services."
        image="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=1920&q=80"
      />

      <main className="max-w-7xl mx-auto px-6 py-20">
        <div className="bg-white rounded-lg shadow-lg p-8 prose prose-gray max-w-none">
          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Acceptance of Terms</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            By accessing and using MyTrip4U ("the Service"), you accept and agree to be bound by the terms and provision of this agreement.
            If you do not agree to abide by the above, please do not use this service.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Use License</h2>
          <p className="mb-4 text-gray-600 leading-relaxed">
            Permission is granted to temporarily access the materials (information or software) on MyTrip4U's website for personal, non-commercial transitory viewing only.
          </p>
          <p className="mb-6 text-gray-600 leading-relaxed">
            This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-600">
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose or for any public display</li>
            <li>Attempt to decompile or reverse engineer any software contained on the website</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Service Description</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            MyTrip4U provides a platform for discovering hotels and restaurants near your location. We aggregate information from various sources to help users find dining and accommodation options.
            While we strive for accuracy, we cannot guarantee the completeness or reliability of all information provided.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">User Responsibilities</h2>
          <p className="mb-4 text-gray-600 leading-relaxed">
            By using our service, you agree to:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-600">
            <li>Provide accurate and current information when contacting us</li>
            <li>Use the service for lawful purposes only</li>
            <li>Not engage in any activity that could harm or disrupt our service</li>
            <li>Respect the intellectual property rights of others</li>
            <li>Not attempt to gain unauthorized access to our systems</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Disclaimer</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            The materials on MyTrip4U's website are provided on an 'as is' basis. MyTrip4U makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Limitations</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            In no event shall MyTrip4U or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on MyTrip4U's website, even if MyTrip4U or a MyTrip4U authorized representative has been notified orally or in writing of the possibility of such damage.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Accuracy of Materials</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            The materials appearing on MyTrip4U's website could include technical, typographical, or photographic errors. MyTrip4U does not warrant that any of the materials on its website are accurate, complete, or current.
            MyTrip4U may make changes to the materials contained on its website at any time without notice.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Links</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            MyTrip4U has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site.
            The inclusion of any link does not imply endorsement by MyTrip4U of the site. Use of any such linked website is at the user's own risk.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Modifications</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            MyTrip4U may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Governing Law</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            These terms and conditions are governed by and construed in accordance with the laws of applicable jurisdiction, and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Contact Information</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            If you have any questions about these Terms of Service, please contact us through our contact form.
          </p>

          <p className="text-sm text-gray-500 mt-8">
            Last Updated: March 2026
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default TermsOfService;